import * as Sentry from '@sentry/react'

// Sentry error tracking.
//
// The DSN is read from an env var so the real value stays out of git and can
// differ per environment. Set REACT_APP_SENTRY_DSN in a .env file (see
// .env.example). When the DSN is absent (e.g. local dev) Sentry stays disabled
// and every helper below is a harmless no-op.
//
// This is intentionally errors-only: no performance tracing and no session
// replay are enabled, so no browsing/interaction data is collected.
const dsn = process.env.REACT_APP_SENTRY_DSN

export function initSentry () {
  if (!dsn) return

  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENV || process.env.NODE_ENV,
    release: process.env.REACT_APP_SENTRY_RELEASE,
    // Errors only — no tracing, no session replay.
    tracesSampleRate: 0,
    // Don't attach IP addresses / user-identifying data.
    sendDefaultPii: false
  })
}

export { Sentry }
